// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VNxpe{display:inline-flex;height:22px;align-items:center;justify-content:center;padding:0 12px;border-radius:100px;color:#fff;font-size:14px;line-height:20px}.VNxpe.CcCW7{background-color:#002b5c}.VNxpe._06bvp{background-color:#6a8dad}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "VNxpe",
	"oxfordBlue": "CcCW7",
	"SteelBlue": "_06bvp"
};
module.exports = ___CSS_LOADER_EXPORT___;
